import { useEffect } from "react";
import { ENUMERATIONS_QUERY_KEYS, enumerationsChannel } from "../../common/api/queries";
import { queryClient } from "../../common/api/queryClient";
import { EnumerationType } from "./enums";

/**
 * Mounted once, in App - invalidates what `invalidateEnumeration` announced in another tab.
 */
export const useEnumerationsSync = () => {
  useEffect(() => {
    const invalidate = ({ data }: MessageEvent<EnumerationType>) =>
      queryClient.invalidateQueries({ queryKey: ENUMERATIONS_QUERY_KEYS.enumerations(data) });

    enumerationsChannel.addEventListener("message", invalidate);

    return () => enumerationsChannel.removeEventListener("message", invalidate);
  }, []);
};
